import { useState } from 'react';
import { ThemeProvider } from '@mui/material';
import '../Styles/CategoryStyles.css';
import { theme } from '../../theme/theme';
import ItemSubCategoryList from '../Statefull/ItemSubCategoryList';
import ItemSubCategoryModal from './Modals/ItemSubCategoryModal';
import { Typography } from '@mui/material';

const ManageItemSubCategory = () => {
  const [mode, setMode] = useState<'add' | 'edit'>('add');
  const [modal, setModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const handleEditCategory = (category: any) => {
    setSelectedCategory(category);
    setMode('edit');
    setModal(true);
  };

  const handleAddCategory = () => {
    setSelectedCategory(null);
    setMode('add');
    setModal(true);
  };

  // const handleCloseModal = () => {
  //   setModal(false);
  //   setSelectedCategory(null);
  // };

  return (
    <ThemeProvider theme={theme}>
      <>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Manage Item Sub Category
        </Typography>
        <ItemSubCategoryList
          editCategory={handleEditCategory}
          handleAddCategory={handleAddCategory}
          expanded={false}
          setExpanded={() => {}}
          mode={mode}
          setMode={setMode}
        />
        
        <ItemSubCategoryModal
          open={modal}
          setOpen={setModal}
          mode={mode}
          initialData={selectedCategory ? {
            id: selectedCategory.id,
            englishName: selectedCategory.nameEnglish,
            arabicName: selectedCategory.nameArabic,
            addedBy: selectedCategory.addedBy,
          } : undefined}
        />
      </>
    </ThemeProvider>
  );
};

export default ManageItemSubCategory;
